<!-- 解决方案大模型页面 -->
<template>
    <div class="page">
        <div class="content-center">
            <iframe
                class="scheme-chat-iframe"
                src="https://ai.591ylc.com/chat/share?shareId=gLuvD0djB1CsBgGNKssDk3mf&showHistory=0"
                frameborder="0"
                allow="microphone *; *"
            ></iframe>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.page {
    padding: 20px 0;
}
.scheme-chat-iframe {
    width: 100%;
    height: calc(100vh - @header-height - 80px);
}
</style>
